// removed by extract-text-webpack-plugin
module.exports = {"container":"container___2LK-9","content":"content___3n8n0","header":"header___2wsbT","description":"description___1brcS","upload":"upload___13rud","spreadsheet":"spreadsheet___2H6w2","htmlReport":"htmlReport___1Uqxw","action":"action____0URA","title":"title___1iJ9V","searchTag":"searchTag___1n5pa","seprator":"seprator___1NxW7","leftContainer":"leftContainer___3WIhz","rightContainer":"rightContainer___1QYsY","inputTitle":"inputTitle___2mx9e","required":"required___3-8C_","tagContainer":"tagContainer___1YT-3","errorTxt":"errorTxt___oARYX","tagDropdown":"tagDropdown___1Y6QC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TagManger/TagManager.module.css
// module id = 390
// module chunks = 0